import { useFormState } from 'react-final-form';
import { getCurrencySymbol } from 'src/shared/utils/currency';
import { useGetUserHoldingQuery } from 'src/shared/api/holding';
import CategoriesGroup from '../../../CategoriesGroup/CategoriesGroup';
import FlexibleRetributionWalletGroup from '../../../FlexibleRetributionWalletGroup/FlexibleRetributionWalletGroup';
import SocialBenefitGroup from '../../../SocialBenefitGroup/SocialBenefitGroup';

export const ConfigurationTab = () => {
  const { values } = useFormState();
  const { data: holdingData } = useGetUserHoldingQuery();
  const currencySymbol = getCurrencySymbol(holdingData?.territory?.isoCode, holdingData?.territory?.currency);

  return (
    <>
      {values.company?.settings?.sbEnabled && (
        <SocialBenefitGroup
          employeeId={values.payflowUserId || values.id}
          sbWalletTotals={values.sbWalletTotals}
          settings={values.settings}
          currencySymbol={currencySymbol}
        />
      )}
      {values.isEligible !== false && <CategoriesGroup flexflowCategoriesLimit={values?.limits} />}
      {values.company?.settings?.frWalletEnabled && (
        <FlexibleRetributionWalletGroup
          frWalletTotals={values.frWalletTotals}
          settings={values.settings}
          currencySymbol={currencySymbol}
          allocationEnabled={values?.limits?.allocationEnabled}
        />
      )}
    </>
  );
};
